/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Proyek_S3Inputs */

const en_tut_proyek_s3 = /** @type {(inputs: Tut_Proyek_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the toolbar, switch between **Daftar · Papan · Tabel**. The board is a drag-and-drop kanban whose columns follow status.`)
};

const id_tut_proyek_s3 = /** @type {(inputs: Tut_Proyek_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di toolbar, ganti tampilan lewat pemilih **Daftar · Papan · Tabel**. Papan adalah kanban yang bisa diseret; kolomnya mengikuti status.`)
};

/**
* | output |
* | --- |
* | "In the toolbar, switch between **Daftar · Papan · Tabel**. The board is a drag-and-drop kanban whose columns follow status." |
*
* @param {Tut_Proyek_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_proyek_s3 = /** @type {((inputs?: Tut_Proyek_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Proyek_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_proyek_s3(inputs)
	return en_tut_proyek_s3(inputs)
});